import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {notifyAnswer as ModifyNotifyOnAnswer} from "./__graphql-types__/notifyAnswer.ts";

type NotifyOnAnswerVariables = {
    key: string;
    notifyOnAnswer: boolean;
};
export const MODIFY_NOTIFICATIONS_FLAG_MUTATION: GqlOperation<
    ModifyNotifyOnAnswer,
    NotifyOnAnswerVariables
> = gqlOp(gql`
    mutation notifyAnswer($key: String!, $notifyOnAnswer: Boolean!) {
        modifyNotifyOnAnswer(
            feedbackKey: $key
            notifyOnAnswer: $notifyOnAnswer
        ) {
            feedback {
                feedbackType
                content
                notifyOnAnswer
            }
        }
    }
`);
